import axiosPrivate from "./axiosPrivate";

const getPagoDetracciones = (periodo, estado = '') => {
  return axiosPrivate.get("pago-detracciones", { params: { periodo, estado } })
    .then(res => res.data);
};

const guardarPagoDetraccion = (data, id = null) => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      formData.append(key, value);
    }
  });

  if (id) {
    formData.append('_method', 'PUT');
    return axiosPrivate.post(`pago-detracciones/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then(res => res.data);
  }

  return axiosPrivate.post("pago-detracciones", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const aprobarPagoDetraccion = (id, observacion_aprobacion = '') => {
  return axiosPrivate.post(`pago-detracciones/${id}/aprobar`, { observacion_aprobacion })
    .then(res => res.data);
};

const observarPagoDetraccion = (id, observacion_aprobacion) => {
  return axiosPrivate.post(`pago-detracciones/${id}/observar`, { observacion_aprobacion })
    .then(res => res.data);
};

const marcarPagoRealizado = (id, fecha_pago, archivo_pago = null) => {
  const formData = new FormData();
  formData.append('fecha_pago', fecha_pago);
  if (archivo_pago) {
    formData.append('archivo_pago', archivo_pago);
  }
  
  return axiosPrivate.post(`pago-detracciones/${id}/pagar`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const validarPagoDetraccion = (id, data) => {
  return axiosPrivate.post(`pago-detracciones/${id}/validar-final`, data)
    .then(res => res.data);
};

const anularPagoDetraccion = (id) => {
  return axiosPrivate.delete(`pago-detracciones/${id}`)
    .then(res => res.data);
};

const PagoDetraccionesService = {
  getPagoDetracciones,
  guardarPagoDetraccion,
  aprobarPagoDetraccion,
  observarPagoDetraccion,
  marcarPagoRealizado,
  validarPagoDetraccion,
  anularPagoDetraccion,
};

export default PagoDetraccionesService;
